
      var _image, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgUserButton = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 27,
  height: 27,
  textRendering: "geometricPrecision",
  viewBox: "0 0 27 27"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
  id: "user-button_527522d016ba5dbf__a",
  width: 27,
  height: 27,
  x: 0,
  y: 0,
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("image", {
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAMAAAC6CgRnAAAABlBMVEVMaXH///+a4ocPAAAAAXRSTlMAQObYZgAAAAlwSFlzAAAD6AAAA+gBtXtSawAAADVJREFUeNrV0bERADAIAkB//6UzATm1Smi/Eaz6MMgiKBll9JBVy4a77DYjHkoXZx1ufx/lAN4oALQb2xUAAAAAAElFTkSuQmCC",
  width: 27,
  height: 27,
  href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAMAAAC6CgRnAAAABlBMVEVMaXH///+a4ocPAAAAAXRSTlMAQObYZgAAAAlwSFlzAAAD6AAAA+gBtXtSawAAADVJREFUeNrV0bERADAIAkB//6UzATm1Smi/Eaz6MMgiKBll9JBVy4a77DYjHkoXZx1ufx/lAN4oALQb2xUAAAAAAElFTkSuQmCC",
  preserveAspectRatio: "none",
  style: {
    imageRendering: "crisp-edges"
  }
}))), _image || (_image = /*#__PURE__*/React.createElement("image", {
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAMAAAC6CgRnAAAAt1BMVEVMaXH//////////////////////////////////////////////////////////////////////////////////////////////v/Qov/79//ZtP/nz//q1v+zav+3cf/v3v/dvP/8+P+zaf/fwP/Nnf/9+v/x4v/kyv+2b//Uqv/16//On//48f/w4f/06f/gwv+/gf/Spv/u3v/Vrf/hw//+/f/y5f/Jlf/Ik//q1f+0a//Qo//6J6WEAAAAF3RSTlMAFbkb9P3c/vyJxYWKHYa8vd3HxBfGHrgaBiYAAAAJcEhZcwAAA+gAAAPoAbV7UmsAAAEFSURBVHjaZVLZQsJADMy2pdutoAJKWpRDRcED8L7w/7/LrZukWZmnbKbJpMkAEEw3zwpbZLkzEKN3apFhh6mmXAc1OgctdWQxhk2YOsZ9EOmkqlpXUvnXdsRay1v/upqwZjPQgB4XpHBN7xLghDrey2QL6mqgS589tWOPQ8ZBnzj1t48hk0MWgrHi6pDKoAjBVnEPIVUAjXKjuDMahuu03obrSA/rlkPWyym6FGqFPKfjDd4RNeWEA8ObPo8nafYCZQifpeer7BPS5g4fkUNe+A5waKUf443uB5Bg9RVRn+8opkgsTqbC7L6VX3xbrzmvZz6a/cxjn3l/lsqfZfpP3rg9X/8CpVYjfs9dS0MAAAAASUVORK5CYII=",
  width: 27,
  height: 27,
  href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAMAAAC6CgRnAAAAt1BMVEVMaXH//////////////////////////////////////////////////////////////////////////////////////////////v/Qov/79//ZtP/nz//q1v+zav+3cf/v3v/dvP/8+P+zaf/fwP/Nnf/9+v/x4v/kyv+2b//Uqv/16//On//48f/w4f/06f/gwv+/gf/Spv/u3v/Vrf/hw//+/f/y5f/Jlf/Ik//q1f+0a//Qo//6J6WEAAAAF3RSTlMAFbkb9P3c/vyJxYWKHYa8vd3HxBfGHrgaBiYAAAAJcEhZcwAAA+gAAAPoAbV7UmsAAAEFSURBVHjaZVLZQsJADMy2pdutoAJKWpRDRcED8L7w/7/LrZukWZmnbKbJpMkAEEw3zwpbZLkzEKN3apFhh6mmXAc1OgctdWQxhk2YOsZ9EOmkqlpXUvnXdsRay1v/upqwZjPQgB4XpHBN7xLghDrey2QL6mqgS589tWOPQ8ZBnzj1t48hk0MWgrHi6pDKoAjBVnEPIVUAjXKjuDMahuu03obrSA/rlkPWyym6FGqFPKfjDd4RNeWEA8ObPo8nafYCZQifpeer7BPS5g4fkUNe+A5waKUf443uB5Bg9RVRn+8opkgsTqbC7L6VX3xbrzmvZz6a/cxjn3l/lsqfZfpP3rg9X/8CpVYjfs9dS0MAAAAASUVORK5CYII=",
  preserveAspectRatio: "none"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-primary, #810ea9)",
  mask: "url(#user-button_527522d016ba5dbf__a)",
  shapeRendering: "crispEdges",
  d: "M0 0h27v27H0z"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"27\" height=\"27\" text-rendering=\"geometricPrecision\" viewBox=\"0 0 27 27\"><defs><mask id=\"layer-0\" width=\"27\" height=\"27\" x=\"0\" y=\"0\" mask-type=\"alpha\" maskUnits=\"userSpaceOnUse\"><image xlink:href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAMAAAC6CgRnAAAABlBMVEVMaXH///+a4ocPAAAAAXRSTlMAQObYZgAAAAlwSFlzAAAD6AAAA+gBtXtSawAAADVJREFUeNrV0bERADAIAkB//6UzATm1Smi/Eaz6MMgiKBll9JBVy4a77DYjHkoXZx1ufx/lAN4oALQb2xUAAAAAAElFTkSuQmCC\" width=\"27\" height=\"27\" href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAMAAAC6CgRnAAAABlBMVEVMaXH///+a4ocPAAAAAXRSTlMAQObYZgAAAAlwSFlzAAAD6AAAA+gBtXtSawAAADVJREFUeNrV0bERADAIAkB//6UzATm1Smi/Eaz6MMgiKBll9JBVy4a77DYjHkoXZx1ufx/lAN4oALQb2xUAAAAAAElFTkSuQmCC\" preserveAspectRatio=\"none\" style=\"image-rendering:crisp-edges\"/></mask></defs><image xlink:href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAMAAAC6CgRnAAAAt1BMVEVMaXH//////////////////////////////////////////////////////////////////////////////////////////////v/Qov/79//ZtP/nz//q1v+zav+3cf/v3v/dvP/8+P+zaf/fwP/Nnf/9+v/x4v/kyv+2b//Uqv/16//On//48f/w4f/06f/gwv+/gf/Spv/u3v/Vrf/hw//+/f/y5f/Jlf/Ik//q1f+0a//Qo//6J6WEAAAAF3RSTlMAFbkb9P3c/vyJxYWKHYa8vd3HxBfGHrgaBiYAAAAJcEhZcwAAA+gAAAPoAbV7UmsAAAEFSURBVHjaZVLZQsJADMy2pdutoAJKWpRDRcED8L7w/7/LrZukWZmnbKbJpMkAEEw3zwpbZLkzEKN3apFhh6mmXAc1OgctdWQxhk2YOsZ9EOmkqlpXUvnXdsRay1v/upqwZjPQgB4XpHBN7xLghDrey2QL6mqgS589tWOPQ8ZBnzj1t48hk0MWgrHi6pDKoAjBVnEPIVUAjXKjuDMahuu03obrSA/rlkPWyym6FGqFPKfjDd4RNeWEA8ObPo8nafYCZQifpeer7BPS5g4fkUNe+A5waKUf443uB5Bg9RVRn+8opkgsTqbC7L6VX3xbrzmvZz6a/cxjn3l/lsqfZfpP3rg9X/8CpVYjfs9dS0MAAAAASUVORK5CYII=\" id=\"convert2-underlay\" width=\"27\" height=\"27\" href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAMAAAC6CgRnAAAAt1BMVEVMaXH//////////////////////////////////////////////////////////////////////////////////////////////v/Qov/79//ZtP/nz//q1v+zav+3cf/v3v/dvP/8+P+zaf/fwP/Nnf/9+v/x4v/kyv+2b//Uqv/16//On//48f/w4f/06f/gwv+/gf/Spv/u3v/Vrf/hw//+/f/y5f/Jlf/Ik//q1f+0a//Qo//6J6WEAAAAF3RSTlMAFbkb9P3c/vyJxYWKHYa8vd3HxBfGHrgaBiYAAAAJcEhZcwAAA+gAAAPoAbV7UmsAAAEFSURBVHjaZVLZQsJADMy2pdutoAJKWpRDRcED8L7w/7/LrZukWZmnbKbJpMkAEEw3zwpbZLkzEKN3apFhh6mmXAc1OgctdWQxhk2YOsZ9EOmkqlpXUvnXdsRay1v/upqwZjPQgB4XpHBN7xLghDrey2QL6mqgS589tWOPQ8ZBnzj1t48hk0MWgrHi6pDKoAjBVnEPIVUAjXKjuDMahuu03obrSA/rlkPWyym6FGqFPKfjDd4RNeWEA8ObPo8nafYCZQifpeer7BPS5g4fkUNe+A5waKUf443uB5Bg9RVRn+8opkgsTqbC7L6VX3xbrzmvZz6a/cxjn3l/lsqfZfpP3rg9X/8CpVYjfs9dS0MAAAAASUVORK5CYII=\" preserveAspectRatio=\"none\"/><rect width=\"27\" height=\"27\" fill=\"var(--theme-primary, #810ea9)\" mask=\"url(#layer-0)\" shape-rendering=\"crispEdges\"/></svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/user-button.527522d016ba5dbf8b9fc6a83070de72.svg"),
        {
          React: SvgUserButton,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      